import { useState, useEffect } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  notification,
  Select,
  Spin,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { get, put } from "../../services";
import dayjs from "dayjs";

const EventForm = () => {
  const { id } = useParams(); // This will get the 'id' from the URL
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [loader2, setLoader2] = useState(false);
  const [information, setInformation] = useState({});
  const [adminData, setAdmins] = useState([]);
  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };
  let options = [];
  // Method for API call
  const getAdmins = () => {
    setLoader(true);
    get(`/user/getAllUsers?page=${1}&limit=${100}`)
      .then((response) => {
        response?.data?.users?.map((item) => {
          options.push({
            value: item?._id,
            label: item?.name,
          });
        });
        setAdmins(options);
        // setLoader(false);
      })
      .catch((err) => {
        // to check token if token expired then logout user
        // setLoader(false);
      });
  };
  // useEffect to get content
  useEffect(() => {
    let tasksAssigned = [];
    get(`/tasks/${id}`)
      .then((response) => {
        response?.data?.assignedUsers?.map((item) => {
          tasksAssigned.push({
            value: item?._id,
            label: item?.name,
          });
        });
        setInformation({ ...response?.data, assignedUsers: tasksAssigned });
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
  }, []);

  // useEffect to get content
  useEffect(() => {
    getAdmins();
  }, []);

  // onFinish handler
  const onFinish = (values) => {
    setLoader2(true);
    let users = [];
    values?.assignedUsers?.map((item) => {
      return users?.push(item?.value);
    });
    const payload = {
      ...values,
      dueDate: values?.dueDate?.$d,
      assignedUsers: users,
    };
    put(`/tasks/${id}`, payload)
      .then(() => {
        setLoader2(false);
        navigate("/tasks");
        openNotification("Success", "Task Updated Successfully");
      })
      .catch(() => {
        setLoader2(false);
        openNotification("Error", "");
      });
  };

  return (
    <>
      <div className="header">
        <h3>Edit Task</h3>
      </div>
      {!loader ? (
        <div className="form_container">
          <Form
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              title: information?.title,
              description: information?.description,
              dueDate: dayjs("2015-06-06", information?.dueDate),
              status: information?.status,
              assignedUsers: information?.assignedUsers,
            }}
          >
            <Form.Item
              name="title"
              label="Title"
              rules={[{ required: true, message: "Please enter your Title" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                { required: true, message: "Please enter your description" },
              ]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item
              className="w-full"
              name="assignedUsers"
              direction="vertical"
              label="Add Users"
              rules={[{ required: true, message: "Please select user" }]}
            >
              <Select
                name="assignedUsers"
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder="Please select"
                defaultValue={[]}
                options={adminData}
              />
            </Form.Item>
            <Form.Item
              name="dueDate"
              label="Date"
              rules={[
                { required: true, message: "Please enter your Due Date" },
              ]}
              className="w-full"
            >
              <DatePicker className="w-full" />
            </Form.Item>
            <Form.Item
              name="status"
              label="Status"
              rules={[{ required: true, message: "Please select status" }]}
            >
              <Select
                options={[
                  {
                    value: "Pending",
                    label: "Pending",
                  },
                  {
                    value: "In Progress",
                    label: "In Progress",
                  },
                  {
                    value: "Completed",
                    label: "Completed",
                  },
                ]}
              />
            </Form.Item>
            <Form.Item>
              <div className="form_submit">
                <Button
                  className="back_button"
                  onClick={() => navigate("/tasks")}
                >
                  Back
                </Button>
                <Button htmlType="submit">
                  {loader2 ? "wait..." : "Save"}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      ) : (
        <div className="spin_information">
          <Spin />
        </div>
      )}
    </>
  );
};
export default EventForm;
